module.exports = __webpack_public_path__ + "static/media/ilustra_88px.b7e18611.svg";